import { useRoutes } from "react-router-dom";
import CreateCard from "../../Component/CreateCard.js"
import EditFormRoute from "../../Component/Forms/EditFormRoute.js"

import AddContent from "./ManageContent/Create.js"
import ViewContent from "./ManageContent/View.js"
import ProtectedRoute from "../RouteProtect.js"


const RoutesArray = [
    {
        path: "*",
        element: <h1>This is 404</h1>
    },
    {
        path: "",
        element:
            (
                <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                    <ViewContent />
                </ProtectedRoute>
            )
    },
    {
        path: "/manageContent",
        element:
            (
                <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                    <ViewContent />
                </ProtectedRoute>
            )
    },
    {
        path: "/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "/addcontent",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <AddContent />
            </ProtectedRoute>
        )
    },
   
];


export default function MangeRoutes() {
    return useRoutes(RoutesArray)
};